/* eslint-disable import/no-cycle */
import { put } from 'redux-saga/effects';
import { Router } from 'router5';
import { IAdvancedStore } from '@mihanizm56/redux-core-modules';
import { loadModule } from '@wildberries/service-modules-load';
import {
  ModulesListType,
  setLoadingStartAction,
  setLoadingStopAction,
  setPlatformModulesAction,
} from '@/_redux/platform-modules';
import { loadScript } from '@/api/requests/load-script';
import { loadStyle } from '@/api/requests/load-style';

export function* fetchPlatformModulesWorkerSaga({
  router,
  store,
}: {
  router: Router;
  store: IAdvancedStore;
}) {
  yield put(setLoadingStartAction());

  try {
    // eslint-disable-next-line no-underscore-dangle
    const platformModules = window.__PLATFORM_MODULES__;
    const modules: ModulesListType = {};

    const { externalPackages } = store.getDependencies();

    yield Promise.all(
      platformModules.map(async ({ name, loadRef, role }) => {
        try {
          const loadScriptUrl: string = loadRef.JS_CDN || loadRef.JS;
          const loadCSSUrl: string = loadRef.CSS_CDN || loadRef.CSS || '';
          const scriptFromCDN = Boolean(loadRef.JS_CDN);
          const cssFromCDN = Boolean(loadRef.CSS_CDN);

          if (role === 'component') {
            await Promise.allSettled(
              [loadCSSUrl, loadScriptUrl].map(async (item) => {
                if (!item) {
                  return;
                }
                if (item.includes('.css')) {
                  return loadStyle(name, '', item, cssFromCDN);
                }

                const {
                  Component,
                  registrationSaga,
                  registrationReducer,
                  registrationActions,
                  registrationRouterMiddlewares,
                  registrationRouterPlugins,
                } = await loadScript(
                  name,
                  '',
                  item,
                  scriptFromCDN,
                  {},
                  // todo fix params type
                  // eslint-disable-next-line no-undefined
                  undefined,
                  // eslint-disable-next-line no-undefined
                  undefined,
                  externalPackages,
                );

                if (registrationSaga) {
                  registrationSaga({ store });
                }

                if (registrationReducer) {
                  registrationReducer({ store });
                }

                if (registrationActions) {
                  registrationActions.forEach((registrationAction: any) => {
                    registrationAction({
                      store,
                      router,
                    });
                  });
                }

                if (registrationRouterMiddlewares) {
                  registrationRouterMiddlewares.forEach(
                    (routerMiddleware: any) =>
                      router.useMiddleware(routerMiddleware),
                  );
                }

                if (registrationRouterPlugins) {
                  registrationRouterPlugins.forEach(
                    (registrationRouterPlugin: any) =>
                      router.usePlugin(registrationRouterPlugin),
                  );
                }

                modules[name] = Component;
              }),
            );
          } else {
            // если это полноценное приложение как модуль
            // // то и подключаем и парсим его как полноценный модуль
            const { routes } = await loadModule({
              name,
              staticURL: '',
              jsUrl: loadScriptUrl,
              fromCDN: scriptFromCDN,
              cdnData: {
                APP_STATIC_NAMESPACE: loadRef.APP_STATIC_NAMESPACE,
              },
              externalPackages,
            });

            const { loadAction } = routes[0] || {};

            const { routes: oldRoutes } = router.getDependencies();

            router.setDependencies({
              routes: [...oldRoutes, ...routes],
            });

            router.add(routes);

            if (loadAction) {
              await loadAction();
            }
          }
        } catch (error) {
          console.error(`Load platform module "${name}" get an error`, error);
        }
      }),
    );

    yield put(setPlatformModulesAction({ modules }));
  } catch (error: any) {
    console.error(
      'fetchPlatformModulesWatcherSaga get an error',
      error.message,
    );
  } finally {
    yield put(setLoadingStopAction());
  }
}
